import { Command } from "./Command";
import { Laya3DRender } from "../../../RenderObjs/Laya3DRender";
import { Pool } from "../../../../utils/Pool";
export class SetShaderDataCMD extends Command {
    static create(shaderData, nameID, value, shaderDataType, commandBuffer) {
        var cmd;
        cmd = SetShaderDataCMD._pool.take();
        cmd._setRenderDataCMD.dest = shaderData;
        cmd._setRenderDataCMD.propertyID = nameID;
        cmd._setRenderDataCMD.dataType = shaderDataType;
        cmd._setRenderDataCMD.value = value;
        cmd._commandBuffer = commandBuffer;
        return cmd;
    }
    constructor() {
        super();
        this._setRenderDataCMD = Laya3DRender.Render3DPassFactory.createSetRenderDataCMD();
    }
    getRenderCMD() {
        return this._setRenderDataCMD;
    }
    recover() {
        SetShaderDataCMD._pool.recover(this);
    }
}
SetShaderDataCMD.ShaderDataType_define = -2;
SetShaderDataCMD._pool = Pool.createPool(SetShaderDataCMD);
export class SetDefineCMD extends Command {
    static create(shaderData, define, addDefine, commandBuffer) {
        var cmd;
        cmd = SetDefineCMD._pool.take();
        cmd._setRenderDefineCMD.dest = shaderData;
        cmd._setRenderDefineCMD.add = addDefine;
        cmd._setRenderDefineCMD.define = define;
        cmd._commandBuffer = commandBuffer;
        return cmd;
    }
    constructor() {
        super();
        this._setRenderDefineCMD = Laya3DRender.Render3DPassFactory.createSetShaderDefineCMD();
    }
    getRenderCMD() {
        return this._setRenderDefineCMD;
    }
    recover() {
        SetDefineCMD._pool.recover(this);
    }
}
SetDefineCMD._pool = Pool.createPool(SetDefineCMD);
